export enum ProviderRateActionsTypes {
  READ = "@@PROVIDER_RATE read",
  READ_STATUS = "@@PROVIDER_RATE read status",
  UPDATE_ONE = "@@PROVIDER_RATE update one",
  UPDATE_ONE_STATUS = "@@PROVIDER_RATE update one"
}
